<form action="" method="post" (ngSubmit)="handleSubmit($event)">
  <label [for]="name" class="score-field">
    <span class="score-field__label" [ngClass]="{
        'score-field__label--bold': isBold,
        'score-field__label--block': fullWidth
      }">{{labelText}}
    </span>
  </label>
  <div class="score-field__container">
    <span class="score-field__input">
      <span *ngIf="!!prefix" class="score-field__prefix">{{ prefix }}</span>
      <input libSpecialNumberInput [maxIntegerDigits]="maxLength" [decimalPoints]="decimalPoints" autocomplete="off"
        [id]="name" [name]="name" type="text" value=""
        [ngClass]="{'score-field__input-nofix' : (!prefix && !postfix) }">
      <span *ngIf="!!postfix" class="score-field__postfix">{{ postfix }}</span>
    </span>
    <button lib-button type="submit" theme="secondary" class="score-field__btn"
      attr.data-trackingid="{{trackingIdPrefix}}scorecard_{{ name }}{{trackingIdPostfix}}">Calculate Rating</button>
  </div>
</form>
